import { HStack, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import {
  formatOrderEtaSlotLabel,
  formatOrderEtaSlotTimings,
  type OrderEtaGaraazSlot,
} from "../utils/orderEtaGaraazSlot";

type GaraazCptSlotLabelProps = {
  slot: OrderEtaGaraazSlot;
  variant: "compact" | "popover";
};

const GaraazCptSlotLabel = ({ slot, variant }: GaraazCptSlotLabelProps) => {
  const label = formatOrderEtaSlotLabel(slot);
  const timings = formatOrderEtaSlotTimings(slot);

  const infoIcon = timings ? (
    <Tooltip hasArrow placement="top" label={timings} whiteSpace="pre-line">
      <IconButton
        variant="unstyled"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        minW="auto"
        h="auto"
        minH="auto"
        p={0}
        cursor="pointer"
        aria-label="Garaaz slot timings"
        onClick={(event) => event.stopPropagation()}
        icon={<InfoOutlineIcon boxSize={variant === "compact" ? 2.5 : 3} />}
      />
    </Tooltip>
  ) : null;

  if (variant === "popover") {
    return (
      <HStack alignItems="center">
        <Text w="40%" noOfLines={1}>
          Garaaz Slot :
        </Text>
        <HStack spacing={1} flex={1} minW={0} justifyContent="flex-start">
          <Text noOfLines={1} textAlign="left">
            {label}
          </Text>
          {infoIcon}
        </HStack>
      </HStack>
    );
  }

  return (
    <Text
      mt="4px"
      minW="4.5rem"
      w="max-content"
      fontSize="12px"
      lineHeight="1.2"
      fontWeight="600"
      textAlign="center"
      color="gray.700"
    >
      {label}
    </Text>
  );
};

export default GaraazCptSlotLabel;
